import React, { useEffect, useState } from "react";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { AntdButton, SelectInput } from "../../../blueplanitUtils/InputField";
import { message, Tooltip } from "antd";
import { Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { deleteContactFormAsync, getAllContactMailAsync, updateContactFormStatusAsync } from "../../../Slices/corpMailsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setLoader } from "../../../Slices/loaderSlice";
import { faSync } from "@fortawesome/free-solid-svg-icons";

const CorpMails = () => {
    const dispatch = useDispatch();
    const tableData = useSelector((state) => state.corpMails.contactMails);
    const [filterStatus, setFilterStatus] = useState("all");

    const handleStatusChange = async (id, newStatus) => {
        try {
            await dispatch(updateContactFormStatusAsync({ id, status: newStatus })).unwrap();
            message.success("Mail Status updated successfully");
            dispatch(getAllContactMailAsync());
        } catch (error) {
            message.error("Failed to update status!");
        }
    };

    const handleDelete = async (id) => {
        try {
            await dispatch(deleteContactFormAsync({ id })).unwrap();
            message.success("Mail Deleted successfully");
            dispatch(getAllContactMailAsync());
        } catch (error) {
            message.error("Failed to delete!");
        }
    };

    useEffect(() => {
        dispatch(getAllContactMailAsync())
    }, [dispatch])

    const messageColumns = [
        { title: "Name", dataIndex: "name", key: "name", width: 150 },
        { title: "Emails", dataIndex: "email", key: "email", width: 200 },
        { title: "Subject", dataIndex: "subject", key: "subject", width: 200 },
        { title: "Message", dataIndex: "message", key: "message", width: 300 },

        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status, record) => (
                <SelectInput
                    value={status}
                    onChange={(value) => handleStatusChange(record._id, value)}
                    style={{ width: "100%" }}
                    options={[
                        {
                            label: (
                                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <i
                                        className="fa-solid fa-envelope"
                                        style={{ fontSize: 16, cursor: "pointer", color: "blue" }}

                                    ></i>
                                    Mark as Read
                                </span>
                            ),
                            value: "read"
                        },
                        {
                            label: (
                                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <i
                                        className="fa-solid fa-envelope"
                                        style={{ fontSize: 16, cursor: "pointer", color: "red" }}

                                    ></i>
                                    Mark as Unread
                                </span>
                            ),
                            value: "unread"
                        }
                    ]}
                />
            )
        },
        {
            title: "Actions",
            key: "actions",
            width: 100,
            render: (_, record) => (
                <Popconfirm
                    title="Are you sure you want to delete?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => handleDelete(record._id)}
                >
                    <AntdButton
                        variant="solid"
                        label="Delete"
                        color="danger"
                    />
                </Popconfirm>
            )
        }

    ];

    const filteredData = tableData.filter(item => {
        if (filterStatus === "all") return true;
        return item.status === filterStatus;
    });

    const handleSync = async () => {
        dispatch(setLoader(true));
        try {
            await dispatch(getAllContactMailAsync());
        } catch (error) {
            console.error('Error refetching contact details', error);
        } finally {
            dispatch(setLoader(false));
        }
    };

    return (
        <div style={{ padding: 20 }}>
            <h2>Corp Recieved Mails</h2>
            <div className="d-flex align-items-center" style={{ gap: '15px', marginBottom: '15px', marginTop: '10px' }}>

                <div style={{ width: 300 }}>
                    <SelectInput
                        value={filterStatus}
                        onChange={(value) => setFilterStatus(value)}
                        style={{ width: "100%" }}
                        placeholder="Filter by Status"
                        options={[
                            { label: "All", value: "all" },
                            { label: "Read", value: "read" },
                            { label: "Unread", value: "unread" }
                        ]}
                    />
                </div>
                <div className="mb-2">
                    <Tooltip title="Sync Now">
                        <FontAwesomeIcon
                            icon={faSync}
                            style={{
                                fontSize: '18px',
                                color: '#1890ff',
                                cursor: 'pointer',
                            }}
                            onClick={handleSync}
                        />
                    </Tooltip>
                </div>
            </div>

            <CustomGridTable
                columns={messageColumns}
                dataSource={filteredData}
                rowKey="id"
                pagination={{
                    showSizeChanger: true
                }}
                Id="ContactFormTable"
            />
        </div>
    );
};


export default CorpMails;
